import { applicationModuleRegistry, Route } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';

export function setupElectronicPatientChart(): void {
  applicationModuleRegistry.register({
    entry: 'PEP#9127',
    id: 'PEP#9127',
    name: 'module.electronic-patient-chart',
    route: ApplicationRoute.ELECTRONIC_PATIENT_CHART,
    routes: [
      {
        children: [
          setupEncounterPatientRoutes(),
          setupClinicalNotesRoutes(),
          setupVitalSignsRoutes(),
          setupNonLabExamsRoutes(),
          setupLaboratoryExamsRoutes(),
          setupDiagnosisRoutes(),
          setupSecurityAlertRoutes(),
          setupPrescriptionsRoutes(),
          setupIntakesAndOutputsRoutes(),
          setupDevicesRoutes(),
          setupScoreAndIndexesRoutes(),
          setupHealthHistoryRoutes(),
          setupWoundsAndDressingsRoutes(),
        ],
        main: true,
        name: 'function.list-of-patients',
        route: ApplicationRoute.PATIENT_LIST,
      },
    ]
  });

  function setupEncounterPatientRoutes(): Route {
    return {
      name: 'function.patient-encounter-details',
      route: ApplicationRoute.ENCOUNTER_PATIENT_DETAIL
    }
  }

  function setupClinicalNotesRoutes(): Route {
    return {
      name: 'function.clinical-notes',
      route: ApplicationRoute.CLINICAL_NOTES_LIST,
    };
  }

  function setupVitalSignsRoutes(): Route {
    return {
      name: 'function.vital-signs',
      route: ApplicationRoute.VITAL_SIGN_LIST,
    };
  }

  function setupNonLabExamsRoutes(): Route {
    return {
      name: 'function.non-lab-exams',
      route: ApplicationRoute.NON_LAB_EXAMS_LIST,
    };
  }

  function setupLaboratoryExamsRoutes(): Route {
    return {
      name: 'function.laboratory-exams',
      route: ApplicationRoute.LAB_EXAMS_LIST,
    };
  }

  function setupDiagnosisRoutes(): Route {
    return {
      name: 'healh.diagnosis',
      route: ApplicationRoute.DIAGNOSIS,
    };
  }

  function setupSecurityAlertRoutes(): Route {
    return {
      name: 'text.security-alert',
      route: ApplicationRoute.EMAR_SECURITY_ALERT,
    };
  }

  function setupPrescriptionsRoutes(): Route {
    return {
      name: 'text.prescriptions',
      route: ApplicationRoute.PRESCRIPTION_CPOE,
    };
  }

  function setupIntakesAndOutputsRoutes(): Route {
    return {
      name: 'text.intakes-and-outputs',
      route: ApplicationRoute.INTAKES_OUTPUTS,
    };
  }

  function setupDevicesRoutes(): Route {
    return {
      name: 'title.form.devices-list',
      route: ApplicationRoute.DEVICES_LIST,
    };
  }

  function setupScoreAndIndexesRoutes(): Route {
    return {
      name: 'title.form.score-and-indexes',
      route: ApplicationRoute.SCORES_LIST,
    };
  }

  function setupHealthHistoryRoutes(): Route {
    return {
      name: 'text.health-history',
      route: ApplicationRoute.HEALTH_HISTORY_LIST,
    };
  }

  function setupWoundsAndDressingsRoutes(): Route {
    return {
      name: 'text.wounds-dressings',
      route: ApplicationRoute.WOUNDS_DRESSINGS_LIST,
    }
  }
}
